/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react'

import { DueOut as ServerDueoutType } from '../../../assets/ts/data/dueout/dueout'
import FileUpload from '../../../components/file-upload/file-upload'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import {
  ALL_SELECT_VALUE,
  MAX_LENGTHS,
  SELECT_OPTION,
} from '../../../utils/constants/global-constants'
import CustomSelect from '../../../utils/controls/custom-select'
import InputText from '../../../utils/controls/input-text'
import RichTextEditor from '../../../utils/controls/rich-text-edit'
import { Dropdown } from '../../../utils/controls/select-options-data'
import { DueoutInputs, ValidationFields } from './dueout-form'

interface DueoutProps {
  PRP: any
  Priority: any
  dueoutInputs: DueoutInputs
  existingDueout: ServerDueoutType
  filesProps: any
  setDueoutInputs: React.Dispatch<React.SetStateAction<DueoutInputs>>
  updateDueoutInput: (key: keyof DueoutInputs, value: any) => void
  validationFields: ValidationFields
}

const DueoutDetails = ({
  PRP,
  Priority,
  dueoutInputs,
  existingDueout,
  filesProps,
  setDueoutInputs,
  updateDueoutInput,
  validationFields,
}: DueoutProps) => {
  const { categories, sections, subcategories, tooltipObj } = useContext(MetadataContext)
  const {
    initialInquiryAndDueoutFilter,
    isSectionChief,
    isSectionOwner,
    isSupervisor,
    isTechnician,
  } = useContext(RoleContext)
  const [categoryOptions, setCategoryOptions] = useState<Array<Dropdown>>([SELECT_OPTION])
  const [subCategoryOptions, setSubCategoryOptions] = useState<Array<Dropdown>>([SELECT_OPTION])

  const [fileError, setFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)

  const sectionBasedDueoutUsers = isSectionChief || isSectionOwner || isSupervisor || isTechnician
  const getSectionBasedDueoutUsers = (): Dropdown[] => {
    if (sectionBasedDueoutUsers) {
      const uniqueSections = new Set()
      const dueoutSections = initialInquiryAndDueoutFilter.sectionCodeFilter
        .flatMap((s) => {
          return sections
            .filter((commonSection) => commonSection.SectionCode === s)
            .map(({ Section, SectionCode }) => {
              const sectionObj = { label: Section, value: SectionCode }
              uniqueSections.add(JSON.stringify(sectionObj))
              return sectionObj
            })
        })
        .filter(
          (sectionObj, index, self) =>
            index ===
            self.findIndex((t) => t.label === sectionObj.label && t.value === sectionObj.value)
        )
      return dueoutSections
    } else {
      return sections.map(({ Section, SectionCode }) => ({
        label: Section,
        value: SectionCode,
      }))
    }
  }
  const generateCategoryOption = (value: null | number) => {
    const matchedCategoryOptions: Dropdown[] = categories
      .filter((item) => item.ParentSectionCode === value)
      .map((item) => ({
        label: item.Label,
        value: item.Value,
      }))

    setCategoryOptions(
      matchedCategoryOptions.length > 1
        ? [SELECT_OPTION, ...matchedCategoryOptions]
        : value === ALL_SELECT_VALUE || null
        ? [SELECT_OPTION]
        : matchedCategoryOptions
    )
  }

  const generateSubcategoryOptions = (value: null | number): Dropdown[] => {
    const matchedSubCategoryOption: Dropdown[] = subcategories
      .filter((item) => item.ParentCategoryCode === value)
      .map((item) => ({
        label: item.Label,
        value: item.Value,
      }))
    if (value === ALL_SELECT_VALUE || matchedSubCategoryOption.length > 1) {
      matchedSubCategoryOption.unshift(SELECT_OPTION)
    } else if (matchedSubCategoryOption.length === 0) {
      matchedSubCategoryOption.push({ label: 'None', value: null })
    }
    setSubCategoryOptions(matchedSubCategoryOption)
    return matchedSubCategoryOption
  }

  const onChangeSection = (e: { label: string; value: number }) => {
    setDueoutInputs((prev) => ({
      ...prev,
      CategoryCode: ALL_SELECT_VALUE,
      SectionCode: e.value,
      SubCategoryCode: ALL_SELECT_VALUE,
    }))
    generateCategoryOption(e.value)
    setSubCategoryOptions([SELECT_OPTION])
  }

  const onChangeCategory = (e: { label: string; value: number }) => {
    const matchedSubCategoryOption = generateSubcategoryOptions(e.value)
    setDueoutInputs((prev) => ({
      ...prev,
      CategoryCode: e.value,
      SubCategoryCode:
        matchedSubCategoryOption.length === 0
          ? 0
          : matchedSubCategoryOption.length === 1
          ? matchedSubCategoryOption[0].value
          : ALL_SELECT_VALUE,
    }))
  }

  const onChangeSubCategory = (e: { label: string; value: number }) => {
    updateDueoutInput('SubCategoryCode', e.value)
  }
  const onChangeTitle = (e: { target: { id: string; value: string } }) => {
    const { id, value } = e.target
    updateDueoutInput(id as keyof DueoutInputs, value)
  }
  const onChangeDescription = (e) => {
    setDueoutInputs((prev) => ({ ...prev, Description: e }))
  }
  const onChangePriority = (e: { label: string; value: string }) => {
    updateDueoutInput('Priority', e.value)
  }
  const changeDate = (e: { target: { id: string; value: string } }) => {
    const { id, value } = e.target
    updateDueoutInput(id as keyof DueoutInputs, value)
  }
  const onChangePRP = (e: { label: string; value: string }) => {
    updateDueoutInput('PRP', e.value)
  }
  //Helper function to get the options when only one option
  const getDropDownOptions = (option) => {
    if (option.length === 1) {
      return option
    } else {
      return [SELECT_OPTION, ...option]
    }
  }
  //Helper function to get the value when only one option
  const getDropDownValue = (option, dropdown) => {
    if (option.length === 1) {
      return option[0].value
    } else {
      return dueoutInputs[dropdown]
    }
  }
  useEffect(() => {
    if (existingDueout) {
      generateCategoryOption(existingDueout.SectionCode)
      const subcategoryOption = generateSubcategoryOptions(existingDueout.CategoryCode)
      if (existingDueout.SubCategoryCode === null && subcategoryOption.length === 0)
        setSubCategoryOptions([{ label: 'None', value: null }])
    }
  }, [existingDueout])
  
  useEffect(() => {
    if (getSectionBasedDueoutUsers().length === 1) {
      const value:any = getSectionBasedDueoutUsers()[0].value
      generateCategoryOption(value)
      setDueoutInputs((prev) => ({
        ...prev,
        SectionCode: value,
      }))
    }
  }, [getSectionBasedDueoutUsers, dueoutInputs.SectionCode])

  return (
    <div className='dueoutsdetailsinfo'>
      <div className='row'>
        <div className='col-md-12  mb-2'>
          <div className='heading p-1'>
            <h2
              aria-label='Dueout Details'
              className='m-0 p-2 color-primary poppins-semibold text-uppercase font-12 maxfitcontent'
              tabIndex={0}
            >
              Dueout Details
            </h2>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='mb-2 col-12 col-md-6 my-1'>
          <InputText
            changeHandler={onChangeTitle}
            className='form-lg font-13 sourcesanspro'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutTitle?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'Title',
              maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY_FIVE,
              name: 'Title',
              placeholder: 'Enter Title',
              value: dueoutInputs.Title,
            }}
            isInfo
            isMandatory
            label='Title'
            ref={validationFields.Title.link}
          />
        </div>

        <div className='mb-2 col-12 col-md-3 my-1'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='Section'
            info={tooltipObj.dueOutSection?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Section'
            name='Section'
            onChange={onChangeSection}
            options={getDropDownOptions(getSectionBasedDueoutUsers())}
            ref={validationFields.Section.link}
            value={getDropDownValue(getSectionBasedDueoutUsers(), 'SectionCode') as number}
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='DashboardCategory'
            info={tooltipObj.dueOutCategory?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Category'
            name='Category'
            onChange={onChangeCategory}
            options={categoryOptions}
            ref={validationFields.Category.link}
            value={dueoutInputs.CategoryCode as number}
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='Sub Category'
            info={tooltipObj.assignDueOutSubCatSelf?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            label='Sub Category'
            name='Sub Category'
            onChange={onChangeSubCategory}
            options={subCategoryOptions}
            value={dueoutInputs.SubCategoryCode as number}
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='Priority'
            info={tooltipObj.dueOutPriority?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Priority'
            name='Priority'
            onChange={onChangePriority}
            options={Priority}
            ref={validationFields.Priority.link}
            value={dueoutInputs.Priority}
          />
        </div>

        <div className='mb-2 col-12 col-md-3 my-1'>
          <InputText
            changeHandler={changeDate}
            className='form-lg font-13 sourcesanspro text-uppercase text-color5 cursor '
            formClassName=' form-vertical'
            info={tooltipObj.dueOutDueDate?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DueDate',
              maxLength: '250',
              name: 'DueDate',
              placeholder: 'Enter Title',
              value: dueoutInputs.DueDate,
            }}
            isInfo
            isMandatory
            label='Due Date'
            min={new Date().toISOString().split('T')[0]}
            ref={validationFields.DueDate.link}
            type='date'
          />
        </div>

        <div className='mb-2 col-12 col-md-3 my-1'>
          <InputText
            changeHandler={changeDate}
            className='form-lg font-13 sourcesanspro text-uppercase text-color5 cursor'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutRNLTD?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'RNLTD',
              name: 'RNLTD',
              placeholder: 'MM/DD/YYYY',
              value: dueoutInputs.RNLTD,
            }}
            isInfo
            label='RNLTD'
            min={new Date().toISOString().split('T')[0]}
            ref={validationFields.RNTD.link}
            type='date'
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <InputText
            changeHandler={changeDate}
            className='form-lg font-13 sourcesanspro text-uppercase text-color5 cursor'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutPDD?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'PDD',
              name: 'PDD',
              placeholder: 'MM/DD/YYYY',
              value: dueoutInputs.PDD,
            }}
            isInfo
            label='PDD'
            min={new Date().toISOString().split('T')[0]}
            ref={validationFields.PDD.link}
            type='date'
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <InputText
            changeHandler={changeDate}
            className='form-lg font-13 sourcesanspro text-uppercase text-color5 cursor'
            formClassName=' form-vertical'
            info={tooltipObj.dueOutDOS?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DOS',
              name: 'DOS',
              placeholder: 'MM/DD/YYYY',
              value: dueoutInputs.DOS,
            }}
            isInfo
            label='DOS'
            min={new Date().toISOString().split('T')[0]}
            ref={validationFields.DOS.link}
            type='date'
          />
        </div>
        <div className='mb-2 col-12 col-md-3 my-1'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
            formClassName='form-vertical'
            id='PRP'
            info={tooltipObj.dueOutPRP?.TooltipDescription}
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            label='PRP'
            name='PRP'
            onChange={onChangePRP}
            options={PRP}
            value={dueoutInputs.PRP}
          />
        </div>
        <div className='mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2'>
          <RichTextEditor
            defaultValue={undefined}
            editorValue={
              existingDueout && typeof dueoutInputs.Description === 'string'
                ? dueoutInputs.Description
                : dueoutInputs.Description === ''
                ? ''
                : null
            }
            formClassName='d-flex flex-column'
            info={tooltipObj.dueOutDescription?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: ' Description ',
              name: ' Description',
              placeholder: 'Enter Description',
            }}
            isInfo
            isMandatory
            label='Description'
            ref={validationFields.Description.link}
            sendValue={onChangeDescription}
            setUserInputs={setDueoutInputs}
          />
        </div>
        <div className='mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2'>
          <FileUpload
            filesProps={{ ...filesProps }}
            formClassName='d-flex flex-column'
            hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
            hintClassName='color-primary'
            info={tooltipObj.dueOutAttachFile?.TooltipDescription}
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'Attach files ',
              name: ' Attach files',
            }}
            isInfo
            label='Attach file (s) '
            note='Screenshots need to be saved locally before uploading into system.'
            noteClassName='color-primary'
            replaceFileProps={{ replaceFile, setReplaceFile }}
            setFileError={setFileError}
          />
        </div>
      </div>
    </div>
  )
}
export default DueoutDetails
